








































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import DictAPI from '@/services/rest/bemob/dictionary';
import LoadingCircle from '@/components/loading-circle.vue'; 

@Component({
  components: {
    LoadingCircle
  }
})
export default class ConnectionType extends Vue {
  @Prop() 
  target: any;

  @Prop() 
  conditions: any;

  loading: boolean = true;
  data: any[] = [];
  selected: any[] = [];
  predicate: string = 'EQUALS';

  mounted() {
    (new DictAPI()).get('connection-types', {}).then((types: any) => {
      this.data = types.map((e: any) => e.name);
      if (this.conditions.connectType) {
        this.predicate = this.conditions.connectType.predicate || this.predicate;
        this.selected = this.data.map((e: any) => this.conditions.connectType.values.indexOf(e) !== -1 && e) || new Array(types.length);
      }
      this.loading = false;
    })
  }

  @Watch('selected', {
    deep: true
  })
  onSelectedChanged(value: any, oldValue: any ) {
    this.$set(this.conditions.connectType, 'values', value.filter((e: any) => e));
  }

  @Watch('predicate')
  onPredicateChanged(value: any, oldValue: any) {
    this.$set(this.conditions.connectType, 'predicate', value)
  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.connectType) {
      this.$set(this.conditions, 'connectType', {
        values: [],
        predicate: 'EQUALS',
      });
    }
  }
}
